<template>
  <SectionSummary>
    <SectionSummaryRow single-column>
      <SectionSummaryText :text="summary.displayName" bold />
    </SectionSummaryRow>
    <SectionSummaryRow v-for="extendedSummary in firstSectionSummaries" :key="extendedSummary.name">
      <template #description>
        <SectionSummaryText :text="extendedSummary.displayName" />
      </template>
      <template #value>
        <SectionSummaryText :text="getFormattedExtendedSummaryValue(extendedSummary)" align-right />
      </template>
    </SectionSummaryRow>
    <SectionSummaryDivider v-if="firstSectionSummaries.length" />
    <SectionSummaryRow v-if="subTotal?.enabled">
      <template #description>
        <SectionSummaryText :text="subTotal.displayName" />
      </template>
      <template #value>
        <SectionSummaryText
          :text="getFormattedExtendedSummaryValue(subTotal)"
          data-external="editor-pricing-table-section-summary-extended-summary-subtotal-value-text"
          align-right
        />
      </template>
    </SectionSummaryRow>
    <SectionSummaryRow v-if="summary.discount?.enabled">
      <template #description>
        <SectionSummaryText :text="summary.discount.displayName" />
      </template>
      <template #value>
        <SectionSummaryText :text="totalDiscountText" red align-right />
      </template>
    </SectionSummaryRow>
    <SectionSummaryRow v-if="summary.tax?.enabled">
      <template #description>
        <SectionSummaryText :text="summary.tax.displayName" />
      </template>
      <template #value>
        <SectionSummaryText :text="totalTaxText" align-right />
      </template>
    </SectionSummaryRow>
    <SectionSummaryRow>
      <template #description>
        <SectionSummaryText :text="summary.price.displayName" bold />
      </template>
      <template #value>
        <SectionSummaryText :text="totalPriceText" bold align-right />
      </template>
    </SectionSummaryRow>
  </SectionSummary>
</template>
<script lang="ts" setup>
import { usePricingTableSummary, type Field, type PricingTable } from '@getaccept/editor-lib';
import { computed, toRefs } from 'vue';
import SectionSummary from '@getaccept/editor-lib/src/components/pricing-table/section-summary/SectionSummary.vue';
import SectionSummaryRow from '@getaccept/editor-lib/src/components/pricing-table/section-summary/SectionSummaryRow.vue';
import SectionSummaryText from '@getaccept/editor-lib/src/components/pricing-table/section-summary/SectionSummaryText.vue';
import SectionSummaryDivider from '@getaccept/editor-lib/src/components/pricing-table/section-summary/SectionSummaryDivider.vue';

const props = defineProps<{
  pricingTable: PricingTable;
  fields: Field[];
}>();

const { pricingTable, fields } = toRefs(props);

const {
  summary,
  enabledExtendedSummaries,
  subTotal,
  totalTaxText,
  totalDiscountText,
  totalPriceText,
  getFormattedExtendedSummaryValue,
} = usePricingTableSummary(pricingTable, fields);

const firstSectionSummaries = computed(() =>
  enabledExtendedSummaries.value.filter(({ name }) => name !== subTotal.value?.name)
);
</script>
